<p-dialog header="Add Carrier Form" [(visible)]="displayDialogFromForm" showEffect="fade" [modal]="true"  [style]="{width: '300px'}" (onHide)="closeAddCarrierDialog()">
    <form [formGroup]="carrierForm">
        <div class="p-grid">
            <div class="form-group p-col">
                <label for="carrierName" class="required">Company Name</label>
                <input pInputText id="carrierName" name="carrierName" formControlName="carrierName" required/>
                <error-block [field]="carrierName" [messages]="{
                  required: 'Company Name is required.'
                }"></error-block>
            </div>
        </div>
        <div class="p-grid">
            <div class="form-group p-col">
                <label for="carrierCode" class="required">SCAC Code</label>
                <input pInputText id="carrierCode" name="carrierCode" formControlName="carrierCode" (change)="codeExists()" required/>
                <error-block [field]="carrierCode" [messages]="{
                    required: 'SCAC Code is required.',
                    pattern: 'SCAC Code must be 2-4 uppercase letters or numerals.',
                    duplicate: 'SCAC Code already exists.'}">
                </error-block>
            </div>
        </div>
        <div class="p-grid">
            <div class="form-group p-col">
                <label for="phoneNumber">Phone Number</label>
                <input pInputText id="phoneNumber" name="phoneNumber" formControlName="phoneNumber" digitOnly maxlength="10" />
            </div>
        </div>
    </form>
    <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
              <div class="centered">
                  <button pButton type="button"
                      [ngClass]="{'p-state-disabled': !carrierForm.valid || working }"
                      [icon]="working ? 'pi pi-spin pi-spinner' : 'pi pi-plus'"
                      class="p-button-success"
                      (click)="saveCarrier();"
                      label="Create Carrier"></button>
              </div>
        </div>
    </p-footer>
</p-dialog>
